import { Suspense } from "react";
import TopBarProgress from "./TopBarProgress";
export default function SuspensedView({ children }) {
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
}
